import React from "react";
import { t } from "ttag";

import { Image } from "../../../common/Image";
import { IOfferDiscount } from "../../../models/catalogue.interfaces";

import styles from "./common-minimal.module.scss";

export const OfferLineMinimal = (props: {
    offerData: IOfferDiscount;
}): React.ReactNode => (
    <section className={styles.virtualLine}>
        {props.offerData.desktop_image && (
            <Image
                alt={props.offerData.short_name}
                src={props.offerData.desktop_image}
            />
        )}
        <div className={styles.titleContainer}>
            <h2 className={styles.productTitle}>{props.offerData.name}</h2>
            <span>
                {t`Qty:`} &nbsp; {props.offerData.freq}
            </span>
        </div>
    </section>
);
